export const GET = "GET"
export const POST = "POST"
export const PATCH = "PATCH"
export const DELETE = "DELETE"

export const appFetch = (
  method, endpoint, body, token, onSuccess, onError, blob = false) => {
  let status = null
  fetch(`${process.env.API_URL}/${endpoint}`, {
    method: method,
    headers: {
      ...(body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...(token ? { "Authorization": `Bearer ${token}` } : {})
    },
    ...(body ? {
      body: (!(body instanceof FormData)
        ? JSON.stringify(body)
        : body)
    } : {})
  }).then(res => {
      status = res.status
      if ((status === 200 || status === 204) && method === DELETE) {
        onSuccess()
      } else if (status === 200 || status === 201) {
        return !blob ? res.json() : res.blob()
      } else {
        throw res
      }
    }
  ).then(
    (result) => {
      onSuccess(result)
    },
    (error) => {
      if (error instanceof TypeError) {
        //no network
        onError("No network")
      } else {
        if (onError) {
          try {
            error.json().then(
              (res) => (onError(res))
            )
          } catch (e) {
            onError(null)
          }
        }
      }
    }
  )
}